import React from 'react';
import { FaCalendarAlt, FaFolder, FaPlay, FaVideo } from 'react-icons/fa';

const BACKEND_URL = '';
const isVideo = (p) => p.media_type === 'video' || (p.content_type && p.content_type.startsWith('video/'));

export function GridView({ photos, onPhotoClick }) {
  return (
    <div data-testid="grid-view">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {photos.map((photo, index) => (
          <div
            key={photo.photo_id}
            className="relative group cursor-pointer rounded-xl overflow-hidden shadow-md aspect-square"
            onClick={() => onPhotoClick(index)}
            data-testid={`gallery-photo-${photo.photo_id}`}
          >
            {isVideo(photo) ? (
              <>
                <video
                  src={photo.file_url?.startsWith('http') ? photo.file_url : `${BACKEND_URL}${photo.file_url}`}
                  className="w-full h-full object-cover"
                  preload="metadata"
                  muted
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <FaPlay className="text-gray-800 text-sm ml-0.5" />
                  </div>
                </div>
                <div className="absolute top-2 left-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1">
                  <FaVideo size={10} /> Video
                </div>
              </>
            ) : (
              <img
                src={photo.file_url?.startsWith('http') ? photo.file_url : `${BACKEND_URL}${photo.file_url}`}
                alt={photo.caption || 'Photo'}
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
                loading="lazy"
              />
            )}

            {/* Always-visible event/album badge */}
            {(photo.event_name || photo.album_name) && (
              <div className="absolute bottom-0 left-0 right-0 px-2 py-1.5 bg-gradient-to-t from-black/70 to-transparent pointer-events-none">
                {photo.event_name && (
                  <p className="text-[11px] text-white flex items-center truncate"><FaCalendarAlt className="mr-1 flex-shrink-0" size={9} />{photo.event_name}</p>
                )}
                {photo.album_name && !photo.event_name && (
                  <p className="text-[11px] text-white flex items-center truncate"><FaFolder className="mr-1 flex-shrink-0" size={9} />{photo.album_name}</p>
                )}
              </div>
            )}

            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
              <div className="absolute bottom-0 left-0 right-0 p-3 text-white">
                {photo.event_name && (
                  <p className="text-xs flex items-center mb-1"><FaCalendarAlt className="mr-1" />{photo.event_name}</p>
                )}
                {photo.album_name && (
                  <p className="text-xs flex items-center mb-1"><FaFolder className="mr-1" />{photo.album_name}</p>
                )}
                <p className="text-xs text-gray-300">{photo.uploader_name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
